import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export interface IGetSiteSAMLConfigurationParams {
}

export class GetSiteSAMLConfigurationRequest extends Request<IGetSiteSAMLConfigurationParams, ISiteSAMLConfiguration> {
  constructor() {
    super('getOrCreateSiteSAMLConfiguration', null);
  }
}
